import {
  USERLIST,
} from '../actions/user';
import {reducerPackage} from "../../utils";

export const userList = reducerPackage(USERLIST);
